
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import InlineXSwitch from 'vux/src/components/inline-x-switch/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {getDevice} from '@/api/device';
import {getLastDeviceData, modifyPointData, doRequest} from "@/api/deviceData";
import InfiniteLoading from 'vue-infinite-loading';
import store from '@/store'
import logoImg from '@/assets/logo2.png'

export default {
name: 'deviceDetail',
directives: {
TransferDom
},
components: {
Grid,
GridItem,
CellBox,
XButton,
Group,
Flexbox,
FlexboxItem,
Toast,
Icon,
Selector,
InlineXSwitch,
Card,
InfiniteLoading,
Confirm
},
data() {
return {
deviceDetail: {},
slaves: [],
pointInfo: [],
lastData: [],
selectValue: '',
selectOptions: [],
dataList: [],
slaveData: {},
inputShow: false,
currItem: {},
logo: logoImg,
show: false,
flag: true,
hasPermission: false
}
},
created() {
this.deviceId = this.$route.params.id;
this.logo = store.getters.logo ? store.getters.logo : this.logo;
if (store.getters.permissions && (store.getters.permissions.includes('iot:deviceData:edit') || store.getters.permissions.includes('*:*:*'))) {
this.hasPermission = true;
}
if (!this.deviceId) {
return;
}
this.getDeviceInfo();
this.getLastData();
},
methods: {
minute(second) {
return Math.ceil(second / 60);
},
onCancel () {
this.flag = false;
this.currItem.value = this.currItem.value == 0 ? 1 : 0;
},
onHide () {
console.log('on hide')
},
onShow () {
console.log('on show')
},
blurPromot(item) {
this.currItem = item;
this.inputShow = true;
},
slaveChange() {
let slave = this.slaveData[this.selectValue];
if (slave) {
this.dataList = slave.datas;

this.show = false;
this.$nextTick(()=> {
this.show = false;
});
}
},
changeSwitch(item) {
this.currItem = item;
if(this.flag) {
this.show = true;
} else {
this.flag = true;
}
},
onConfirm (msg) {
if (msg) {
this.currItem['value'] = msg;
this.editDataPoints(this.currItem);
} else {
this.$vux.toast.show({
type: 'warn',
text: '设置值不能为空'
})
}
},
onConfirmSwitch() {
this.editDataPoints(this.currItem);
},
async editDataPoints(item) {
modifyPointData(item).then(response => {
this.$vux.toast.show({
text: '修改成功',
time: 3000
})
}).catch(error => {
this.$vux.toast.show({
type: 'warn',
text: error
})
});
},
getDeviceInfo() {
getDevice(this.deviceId).then(response => {
this.deviceDetail = response.data;
if (this.deviceDetail.slaves) {
this.slaves = JSON.parse(this.deviceDetail.slaves)
}
});
},
async getDataPointInfoByDevice() {

},
getLastData() {
getLastDeviceData(this.deviceId).then(response => {
this.dataList = this.lastData = response.data;
if (this.lastData) {
this.selectOptions = []
this.slaveData = {}
this.lastData.forEach(item => {
if (this.slaveData[item.slaveId]) {
this.slaveData[item.slaveId].datas.push(item)
} else {
this.slaveData[item.slaveId] = {datas: [], slaveName: item.slaveName}
this.slaveData[item.slaveId].datas.push(item)
this.selectOptions.push({ key: item.slaveId, value: item.slaveName })
}
})
this.slaveChange();
}
});
},
handleSendCmd() {
doRequest(this.deviceId).then(() => {
this.$vux.toast.show({
text: '指令已下发，请刷新数据，勿频繁点击',
time: 3000
})
}).catch(error => {
this.$vux.toast.show({
type: 'warn',
text: error
})
});
},
}
}



// WEBPACK FOOTER //
// ./src/components/device-detail.vue